import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { Search } from 'semantic-ui-react';
import { useTranslate } from 'react-admin';

import { search } from '../../../../services/api';

import 'semantic-ui-css/components/search.css';
import 'semantic-ui-css/components/icon.css';
import 'semantic-ui-css/components/input.css';


// const searchStyles = {
// 	flex: 1,
// 	marginLeft: '25px'
// };

const boxSx = {
	flex: 1,
	marginLeft: '25px',
	'& .ui.search': {
		'& input': {
			backgroundColor: theme => theme.palette.mode === 'dark' ? theme.palette.action.hover : '#FFF',
			borderRadius: '8px',
			color: theme => theme.palette.text.primary,
			border: 'none',
			'&:focus': {
				borderColor: theme => theme.palette.primary.main
			},
			'&:placeholder': {
				color: theme => theme.palette.text.secondary,
			},
			'& + i.icon': {
				color: theme => theme.palette.text.primary,
			}
		},
		'& > .results': {
			borderColor: theme => theme.palette.divider,
			backgroundColor: theme => theme.palette.background.paper,
			borderRadius: '6px',
			borderWidth: '1px !important',
			boxShadow: 'none',
			overflow: 'hidden'
		},
		'& .results .category': {
			backgroundColor: theme => theme.palette.background.default + ' !important',
			'.name': {
				color: theme => theme.palette.text.primary,
				borderColor: theme => theme.palette.divider
			},
			'.results': {
				borderColor: theme => theme.palette.divider
			},
			'&:last-child .name, &:last-child .results': {
				borderBottom: 'none'
			}
		},
		'& .results .category .results': {
			backgroundColor: theme => theme.palette.background.paper,
			'.result': {
				borderColor: theme => theme.palette.divider
			},
			'.result:hover': {
				backgroundColor: theme => theme.palette.action.hover
			},
			'.title': {
				color: theme => theme.palette.text.primary,
			},
			'.description': {
				color: theme => theme.palette.text.secondary,
			}
		}
	}
};

const SearchBar = ({ staticContext, ...props }) => {
	const [value, setValue] = useState('');
	const [results, setResults] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const translate = useTranslate();

	const handleResultSelect = (e, { result }) => {
		navigate(result.url);
		setValue('');
		setResults([]);
	};

	const handleSearchChange = async (e, { value }) => {
		setIsLoading(true);
		setValue(value);
		setResults([]);
	};

	useEffect(() => {
		const timerId = setTimeout(async () => {
			if (value.length >= 3) {
				const data = await search(value);
				let cleanData = {};
				for (const [key, value] of Object.entries(data)) {
					if (value?.results?.length > 0) {
						cleanData = { ...cleanData, [key]: value };
					}
				}
				setIsLoading(false);
				setResults(cleanData);
			}
			else if (value.length === 0) {
				setIsLoading(false);
				setResults([]);
			}
		}, 1000);

		return () => {
			clearTimeout(timerId);
		};
	}, [value]);

	return (
		<Box sx={boxSx}>
			<Search
				category
				minCharacters={2}
				loading={isLoading}
				onResultSelect={handleResultSelect}
				onSearchChange={handleSearchChange}
				results={results}
				value={value}
				placeholder={translate("Search") + "..."}
				// style={searchStyles}
				size="small"
				showNoResults={false}
				{...props}
			/>
		</Box>
	);
};

export default SearchBar;
